export default __webpack_public_path__ + "static/media/jpg.a7119af1.svg";